import React, { useState } from "react";
import { Input } from "semantic-ui-react";

import "./PasswordInput.scss";

const PasswordInput = ({ value, onChange, showAsteriskPlaceholder, ...restProps }) => {
  const [passwordValue, setPasswordValue] = useState(showAsteriskPlaceholder ? "************" : value);

  const handleFocus = () => {
    if (showAsteriskPlaceholder) setPasswordValue("");
  };

  const handleChange = (e, data) => {
    setPasswordValue(e.target.value);
    onChange(e, data);
  };

  return <Input {...restProps} type="text" autoComplete="off" value={passwordValue} onChange={handleChange} onFocus={handleFocus} className="PasswordInput" />;
};

export default PasswordInput;
